module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_029.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_029.png
// module id = 2345
// module chunks = 5